import Vue from 'vue';
import VueRouter from 'vue-router';
import routerGuards from './routerGuards';

// const routeArr = {
//     ...AdvertiseRouters
// };

const routes = [
    // {
    //     path: '/',
    //     redirect: '/home',
    //     meta: {
    //         title: '首页',
    //     },
    // },
    {
        path: '/',
        name: 'Home',
        // children: routeArr,
        component: () => import(/* webpackChunkName: "main_home" */ '@/views/home/index.vue'),
        meta: {
            title: '首页',
            storage: [
                'adDict.toutiao',
                'adDict.gdt',
                'adDict.facebook',
                'adDict.kuaishou',
                'adDict.home',
                'materialDict',
                'creativeDict.facebook',
                'creativeDict.toutiao',
                'creativeDict.gdt',
                'creativeDict.kuaishou',
                'creativeDict.tiktok',
            ],
        },
    },
    {
        path: '/login',
        component: () => import(/* webpackChunkName: "main_login" */ '@/views/login/index.vue'),
        name: 'Login',
        meta: {
            title: '登录',
        },
    },
];

const router = new VueRouter({
    mode: 'history',
    routes,
});

routerGuards.beforeRouter(router);

Vue.use(VueRouter);

export default router;
